export const PROTOCOL_STATUS_LABEL = {
  OPEN: 'Aberto',
  CLOSED: 'Encerrado',
}
